import { merge } from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import './assets/css/module/base/selector.css'
import Dialog from './components/molecules/ModalDialog'
import router from './router'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

if (DEVELOPMENT) {
  require('@/__INITIAL_STATE__')

  // JSエラー確認用
  if (location.search.indexOf('error=js') >= 0) {
    Vue.notFound() // 存在しないメソッド
  }
}

if (window.__INITIAL_STATE__) {
  store.replaceState(merge(store.state, window.__INITIAL_STATE__))
}

router.beforeEach((to, from, next) => {
  Dialog.closeAll()
  next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
